import { css } from '@emotion/react'
import theme from '../theme'

export default css`
    :root {
        --swiper-pagination-color: ${theme.colors.accent.palePurple};
    }
`
